import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const deleteVersion = ({ jobAdID, versionID }) => {
  return axios.delete(`/api/job_ads/${jobAdID}/versions/${versionID}`);
};

export const useDeleteVersion = (refetch) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: deleteVersion,
    onSuccess: () => {
      enqueueSnackbar('Version deleted successfully', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      if (refetch) refetch();
    },
    onError: (error) => {
      console.log(error);
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
